module.exports = __webpack_public_path__ + "img/78ne.e132f3b2.svg";